import { persistReducer as rpPersistReducer } from "redux-persist";
import isServer from "helpers/isServer";

// If we're on the server, just return the reducer without persisting
const persistReducer = isServer ? (_, reducer) => reducer : rpPersistReducer;

export default persistReducer;
